import https from "../pluggins/http";

export const fetchAlbaranes = async ({ id, rol, fecha } = {}) => {
  try {
    const response = await https.post("albaranes?today=true", {
      id,
      rol,
      fecha,
    });
    return Object.values(response?.data?.data);
  } catch (_error) {
    throw _error;
  }
};

export const fetchCamiones = async ({ id, conductor_id } = {}) => {
  try {
    const response = await https.post("camiones", {
      id,
      conductor_id,
    });
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    throw _error;
  }
};

export const fetchObras = async ({ operador, conductor_id } = {}) => {
  try {
    const response = await https.post("obras", { operador, conductor_id });
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    throw _error;
  }
};

export const fetchTipos = async () => {
  try {
    const response = await https.get("tipos");
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    throw _error;
  }
};

export const fetchVertederos = async (operador) => {
  try {
    const response = await https.get("vertederos", {
      params: operador ? { operador } : {},
    });
    return Array.isArray(response?.data?.data) ? response?.data?.data : [];
  } catch (_error) {
    throw _error;
  }
};

export const fetchPreferences = async (id) => {
  try {
    // console.log(id);
    const response = await https.get(`preferences/${id}`);
    console.log(response);
    return response;
  } catch (_error) {
    throw _error;
  }
};

export const duplicarAlbaran = async (id) => {
  try {
    const response = await https.post(`albaranes/${id}/duplicate`);
    return response?.data?.data;
  } catch (_error) {
    throw _error;
  }
};

// Clientes con las direcciones de contenedores asignadas al conductor y destinos posibles.
export const fetchClientesContenedor = async (conductor_id) => {
  try {
    const response = await https.get("contenedores/clientes", {
      params: { conductor_id },
    });
    return {
      clientes: Array.isArray(response?.data?.data) ? response.data.data : [],
      vertederos: Array.isArray(response?.data?.vertederos)
        ? response.data.vertederos
        : [],
    };
  } catch (_error) {
    throw _error;
  }
};

const SERVICIOS_CONTENEDOR = {
  llevada: "Llevada",
  cambio: "Cambio",
  retirada: "Retirada",
};

export const servicioLabel = (servicio) =>
  SERVICIOS_CONTENEDOR[servicio] || servicio || "-";

// "Entrega X · Retirada Y" con solo las cajas que aplican al servicio.
export const cajasLabel = (albaran) => {
  const partes = [];
  if (albaran?.tipo_servicio !== "retirada") {
    partes.push(`Entrega ${albaran?.num_caja_entrega || "-"}`);
  }
  if (albaran?.tipo_servicio !== "llevada") {
    partes.push(`Retirada ${albaran?.num_caja_retirada || "-"}`);
  }
  return partes.join(" · ");
};

/**
 * DI de contenedor al que aún le faltan datos para el PDF (p. ej. pre-carga
 * sin residuo/destino/capacidad).
 */
export const diContenedorIncompleto = (albaran) => {
  if (!albaran || albaran.tipo !== "contenedor") return false;
  const servicio = albaran.tipo_servicio;
  if (!servicio || !SERVICIOS_CONTENEDOR[servicio]) return true;
  const capacidad = Number(albaran.capacidad_m3);
  if (!Number.isFinite(capacidad) || capacidad < 1 || capacidad > 255) return true;
  if (!String(albaran.camion || "").trim()) return true;
  if (servicio === "llevada") {
    return false;
  }
  const residuo =
    albaran.tipo_residuo ||
    albaran.residuo?.id ||
    albaran.residuo?.nombre;
  const destino =
    (albaran.destino && albaran.destino !== "-") ||
    albaran.verts?.id ||
    albaran.verts?.nombre;
  return !residuo || !destino;
};
